import { render, staticRenderFns } from "./app-overlay.vue?vue&type=template&id=51ffcfa6&scoped=true&"
import script from "./app-overlay.vue?vue&type=script&lang=js&"
export * from "./app-overlay.vue?vue&type=script&lang=js&"
import style0 from "./app-overlay.vue?vue&type=style&index=0&id=51ffcfa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffcfa6",
  null
  
)

export default component.exports